'use client';

import { useContext } from 'react';

import { AccordionContainer } from '@/components/AccordionContainer';
import { Container } from '@/components/Container';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { SettingsContext } from '@/contexts/SettingsContext';
import useTranslation from '@/hooks/useTranslation';

export const SectionGuideline = () => {
  const t = useTranslation();
  const { guidelines, fetchGuidelines } = useContext(SettingsContext);
  return (
    <AccordionContainer keyName={'GUIDELINE'} visibleTitle={t('section.GUIDELINE')} onOpen={fetchGuidelines}>
      <Container sx={{ padding: 16 }}>{!guidelines ? <LoadingSpinner /> : guidelines}</Container>
    </AccordionContainer>
  );
};
